import React from "react";
import styles from "../../styles/style";
import CountDown from "./CountDown";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addToCart } from "../../redux/actions/cartAction";

const EventCard = ({ active, data }) => {
  const { cart } = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  console.log("EventCard rendered, props:", { active, data });

  if (!data) {
    return <div>No event data available</div>;
  }

  const addToCartHandler = (data) => {
    const isItemExists =
      cart && cart.find((i) => (i._id || i.id) === (data?._id || data?.id));
    if (isItemExists) {
      toast.error("Item already in cart!");
    } else {
      if (data?.stock < 1) {
        toast.error("Product already in cart!");
      } else {
        const cartData = { ...data, qty: 1 };
        dispatch(addToCart(cartData));
        toast.success("Item added to cart successfully!");
      }
    }
  };

  console.log(data);

  return (
    <div
      className={`w-full block bg-white rounded-lg px-16 py-16 ${active ? "" : "mb-12"}
       lg:flex p-2`}
    >
      <div className="w-[full] lg:w-[40%] m-auto">
        <img
          src={data?.images?.[0]?.url || "/placeholder.png"}
          alt={data?.name || "Event"}
        />
      </div>
      <div className="w-full lg:w-[50%] flex flex-col justify-start">
        <h2 className={`${styles.productTitle}`}>{data?.name}</h2>
        <p>{data?.description}</p>
        <div className="flex py-2 justify-between">
          <div className="flex">
            <h5 className="font-[500] text-[10px] text-[#d55b45] pr-3 line-through">
              {data?.originalPrice}$
            </h5>
            <h5 className="font-bold text-[20px] text-[#152942] font-Roboto">
              {data?.discountPrice}$
            </h5>
          </div>
          <span className="pr-3 font-[400] text-[17px] text-[#40B884]">
            {data?.soldOut} Sold
          </span>
        </div>
        <CountDown data={data} />
        <br />
        <div className="flex items-center">
          <Link to={`/product/${data?._id || data?.id}?isEvent=true`}>
            <div className={`${styles.button} text-[#fff]`}>See Details</div>
          </Link>
          <div
            className={`${styles.button} text-[#fff] ml-5`}
            onClick={() => addToCartHandler(data)}
          >
            Add to Cart
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
